import { render } from "./ReviewGoals.vue?vue&type=template&id=e40cdf2a"
import script from "./_ReviewGoals.js?vue&type=script&lang=js&external"
export * from "./_ReviewGoals.js?vue&type=script&lang=js&external"

import "./_ReviewGoals.less?vue&type=style&index=0&lang=less&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__